<template>
  <div>
    <div class="logo"><img :src="require('../../assets/icons/file.png')" alt=""></div>
    <p class="padlr10 phead">您的志愿列表生成成功，请点击右上角在Sarari中打开下载。</p>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
    export default {
        name: "download",
        mounted() {
          if (!isWechat()) {
            Toast("导出中...");
            try {
               //location.href = location.origin+"/wx/downloadCollections?studentId=" + this.$route.query.studentId;
               location.href = location.origin+"/wx/download/" + this.$route.query.studentId+".xlsx";
            } catch (e) {

            }
          }
      }
    }
</script>

<style scoped>
  .logo{
    text-align: center;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/download.vue